
export default {
  name: 'text-animation',
  mixins: [],
  data () {
    return {
      needIntersection: true,
      mobile: true
    }
  },
  props: {
    delay: 0
  },
  mounted () {
    this.$el._show = this.show.bind(this)
    this.$el._hide = this.hide.bind(this)
    this.mobile = this.$store.state.ua.platform.type !== 'desktop'
    this.$nextTick(() => {
      // this.splited = new SplitText(this.$el.querySelectorAll('.text-animation p'), { type:"words, lines", linesClass:'line-element'})
      // this.linesDelay()
      if(window.innerWidth > 813  ) {
        this.splited = new SplitText(this.$el.querySelectorAll('.text-animation>*'), { type: 'words, lines', linesClass: 'line-element' })
        this.makeLines()

      }
    })
  },
  methods: {
    show () {
      this.$el.classList.remove('up')
      this.$el.classList.remove('down')
    },
    hide (up = true) {
      if (up) {
        this.$el.classList.add('up')
      } else {
        this.$el.classList.add('down')
      }
    },
    makeLines () {
      let lastTop = 0
      let lines = [[]]
      let lineIdx = 0
      for (let i = 0; i < this.splited.words.length; i++) {
        const word = this.splited.words[i]
        const bounds = word.getBoundingClientRect()
        if (word.parentElement.getAttribute('href')) {

        }
        if (this.splited.words[i + 1]) {
          if (word.parentElement.getAttribute('href') && !this.splited.words[i - 1].parentElement.getAttribute('href')) {
            word.innerHTML = `<span><a href=${word.parentElement.getAttribute('href')}>${word.innerHTML}</span>`
          }
        }

        if (i == 0) {
          lastTop = bounds.top
        }
        if (bounds.top > lastTop) {
          lastTop = bounds.top
          lines.push([])
          lineIdx++
        }
        lines[lineIdx].push(word)
      }
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i]
        let lineDom = `<span style="transition-delay: ${i / 30}s" class="text-animation-line-wrapper">`
        for (let j = 0; j < line.length; j++) {
          const word = line[j]
          lineDom += word.outerHTML + ' '
        }
        lineDom += '</span>'
        for (let j = 1; j < line.length; j++) {
          const word = line[j]
          word.remove()
        }
        line[0].innerHTML = lineDom
        line[0].classList.add('text-animation-line')
        this.splited.lines.push(line[0])
      }
    },

    linesDelay () {
      this.splited.lines.map((el, index) => {
        el.style.transitionDelay = `${index / 30}s`
        el.classList.add('text-animation-line-wrapper')
      })

      Array.from(this.$el.querySelectorAll('a')).map(el => {
        el.setAttribute('data-name', el.textContent)
      })
    }

  }
}
